import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Bazel = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M7.44001 3L11.7553 7.31532L7.44001 11.6306L3.12469 7.31532L7.44001 3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.1796 7.73958L7.86427 12.0549L12.1796 16.3702L16.4949 12.0549L12.1796 7.73958Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M7.14001 16.0702V12.1792L3.00043 8.03958V11.9306L7.14001 16.0702Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M7.74001 12.7792V16.6702L11.8796 20.8098V16.9187L7.74001 12.7792Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.4796 16.9187V20.8098L16.6192 16.6702V12.7792L12.4796 16.9187Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M21.3588 11.9306L17.2192 16.0702V12.1792L21.3588 8.03958V11.9306Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.9192 11.6306L21.2345 7.31532L16.9192 3L12.6039 7.31532L16.9192 11.6306Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Bazel;
